import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";
import { USER_ROLES } from "@/core/enums/USER_ROLES";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.AGENT_MANAGEMENT,
    name: "agentManagement",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_MANAGEMENT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_MANAGEMENT.PERMISSIONS,
    },
    component: () => import("@/modules/Agent/views/AgentManagment.vue"),
  },
  {
    path: `${PATH.AGENT_BULK_IMPORT}/:orgId?`,
    name: "agentBulkImport",
    meta: {
      roles: [
        ...ROLES_AND_PERMISSION_ON_ROUTES.AGENT_MANAGEMENT.ROLES,
        USER_ROLES.SUPER_USER,
        USER_ROLES.OPERATIONS,
      ],
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_MANAGEMENT.PERMISSIONS,
    },
    component: () => import("@/modules/Agent/views/BulkImportUsers.vue"),
  },
  {
    path: `${PATH.AGENT_PERMISSIONS}/:id`,
    name: "agentPermissions",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_PERMISSIONS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_PERMISSIONS.PERMISSIONS,
    },
    component: () => import("@/modules/Agent/views/AgentView.vue"),
  },
  {
    path: `${PATH.AGENT_PRICING}/:agentId`,
    name: "Agent Pricing",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_PRICING.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_PRICING.PERMISSIONS,
    },
    component: () => import("@/modules/Agent/views/AgentPricing.vue"),
  },
];

export default routes;
